export function extractDomain(url: string) {
  const domain = new URL(url).hostname

  return domain
}
